module.exports = __webpack_public_path__ + "static/img/40008 (5).cefba18.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40008 (5).webp
// module id = zRTR
// module chunks = 14